import React from 'react'
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom'
import { Login } from '../../pageLogin'
// import { Home } from '../../pageHome'
import { PageHome } from '../pageHome'
import { Preloader } from '../../pagePreloader'
import { Admin } from '../../pageAdmin'
// import { ReportPage } from '../../pageReport'
import { UtilitiesPage } from '../../pageUtils'
import { useUserContext } from '../contextProviders/userContext'
import { useAppContainerContext } from '../appContainer/context'
import { useDiagnosticsContext } from '../contextProviders/diagnosticsContext'
import { usePhotoManagerContext } from '../contextProviders/photoManagerContext'
// import { TestPage } from '../testPage'
// import { DoubleTest } from '../double_test'
import { ReportPageV2 } from '../pageReportV2'
import { CLI_V2, REP_V2} from '../../../shared/Data/typeDirs'
import { PageClientV2 } from '../pageClientsV2'
const routes = [
  { path: "/login", name: "Login", Component: Login },
  { path: "/home", name: "Home", Component: PageHome },
  { path: "/preloader", name: "Loading . . . ", Component: Preloader },
  { path: `/${REP_V2}/:_id`, name: REP_V2, Component: ReportPageV2 },
  { path: "/admin", name: "Admin", Component: Admin },
  // { path: "/test", name: "Test", Component: TestPage },
  // { path: "/dtest", name: "DOUBLE Test", Component: DoubleTest },
  { path: "/utils", name: "Utilities", Component: UtilitiesPage },
  { path: `/${CLI_V2}`, name: "Clients", Component: PageClientV2 },
]

function PrivateRoute({ children }) {
  const { user } = useUserContext()
  
  if (!user) {
    return <Navigate to="/login" replace />
  }
  
  return children
}

export function AppRouter({ setScrollCallback }) {
  const {user, login:logIn, logout:logOut, setUser} = useUserContext()
  const diagnostics = useDiagnosticsContext()
  const {setMenuOptions, setTitle, setNavi, setHeader, clearGenericContainers} = useAppContainerContext()
  // const displayNotif = useNotificationContext()
  const navigate = useNavigate()
  const {
    copyQueueManager,
    photoUploadManager,
    oaPhotoManager,
  } = usePhotoManagerContext()

  function changeScrollCallback(cb){
    setScrollCallback(
      ()=>cb
    )
  }

  // console.log('MyAppRouter render', user)

  const childProps = {
    currentUser: user,
    user,
    setUser,
    logIn,
    logOut,
    navigate: navigate,
    setNavi,
    diagnostics,
    setMenuOptions,
    setTitle,
    copyQueueManager,
    photoUploadManager,
    oaPhotoManager,
    // displayNotif,
    setHeader,
    registerChildGoHome:()=>{},
    registerScrollChange:changeScrollCallback,
    unregisterScrollChange:()=>changeScrollCallback(()=>{}),
    clearGenericContainers
  }
  
  return (
    <Routes>   
      
      <Route path="/" element={
        user ? <Navigate to="/preloader" replace /> : <Login {...childProps} />
      } />

      {routes.map(({ path, Component }, key) => (
        <Route 
          key={key} 
          path={path} 
          element={
            path === "/login" ? (
              <Component {...childProps} />
            ) : (
              <PrivateRoute>
                <Component {...childProps} />
              </PrivateRoute>
            )
          } 
        />
      ))}
    </Routes>
  )
}